import React, { Fragment, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import { AxisDate } from "../util/AxisDateTime";
import { ShiftTypeString } from "../util/ShiftOptionsSelection";
import AxisSpinner from "./AxisSpinner";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";
import { BsXCircle } from "react-icons/bs";

const BulkDeleteShifts = ({
  shifts,
  onComplete,
  close = null,
  isArchive = false,
}) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);

  const getSelectedShifts = () => {
    return shifts.filter((shift) => shift?.selected === true);
  };

  const getSelectShiftIds = () => {
    return getSelectedShifts().map((shift) => shift?.id);
  };

  const onSave = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };
      const payload = getSelectShiftIds();

      const endPoint = isArchive
        ? "/api/backoffice/shifts/bulk_archive_shift_cancel"
        : "/api/backoffice/shifts/bulk_shift_cancel";

      await authAxios().post(endPoint, payload, config);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("error:");
      console.log(err);
    }

    onComplete();
  };

  const displaySelection = () => {
    const selected = getSelectedShifts();
    const isEmpty = selected.length <= 0;
    if (isEmpty) {
      return <div>No Shifts selected</div>;
    }
    return (
      <Fragment>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>REFERENCE</th>
              <th>TRUST</th>
              <th>FACILITY</th>
              <th>WARD</th>
              <th>DATE</th>
              <th>TYPE</th>
            </tr>
          </thead>
          <tbody>
            {selected.map((shift) => (
              <tr key={shift?.id}>
                <td>{shift?.notificationId}</td>
                <td>{shift?.trust?.shortName}</td>
                <td>{shift?.facility?.name}</td>
                <td>{shift?.ward?.identifier}</td>
                <td>{AxisDate(shift?.start)}</td>
                <td>{ShiftTypeString(shift?.shiftType)}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Col className={"justify-content-center"}>
          <AxisSpinner loading={loading} />
        </Col>
        <ButtonModalFormSaveClose
          close={close}
          saveName={
            <Fragment>
              <BsXCircle className={"icon-right-spacing"} /> Bulk Delete
            </Fragment>
          }
          formSave={onSave}
          saveButtonClassName={
            "shift-button-deny-reopen icon-text-wrapper w-100 justify-content-center"
          }
          loading={loading}
        />
      </Fragment>
    );
  };

  return displaySelection();
};

export default BulkDeleteShifts;
